export class ProductionType {
    Id: number;
    Name: string;
    FeatureId: number;
    FeatureKeyId: number;
    Status: string;
    CreatedBy: number;
    CreatedOn: Date;
    ModifiedBy: number;
    ModifiedOn: string;
}
